export const GUIDE_PATH = '/kb';

export function safeGuideUrl(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  for (const char of value) {
    if (char.charCodeAt(0) <= 32 || char === '\\') return undefined;
  }
  if (/^(?:\/(?!\/)|#|mailto:)/i.test(value)) return value;
  try {
    const url = new URL(value);
    if (url.protocol === 'https:' && !url.username && !url.password) return value;
    if (url.protocol === 'http:' && ['127.0.0.1', 'localhost'].includes(url.hostname)) return value;
  } catch {
    /* An unsupported URL is rendered without an active link. */
  }
  return undefined;
}

export function guideLink(
  href: unknown,
  apiOrigin: string,
  basePath = GUIDE_PATH,
): string | undefined {
  const safe = safeGuideUrl(href);
  if (!safe) return safe;
  if (safe.startsWith('#/')) {
    const target = new URL(safe.slice(1), apiOrigin);
    const slug = target.pathname.slice(1);
    if (!/^[a-z0-9][a-z0-9-]{0,79}$/.test(slug)) return undefined;
    const section = target.searchParams.get('section');
    return `${basePath}/${encodeURIComponent(slug)}${section ? `#${encodeURIComponent(section)}` : ''}`;
  }
  if (safe.startsWith('#') || safe.startsWith('mailto:')) return safe;
  const url = new URL(safe, apiOrigin);
  const match =
    /^\/api\/product-guide-v2\/(?:(?:public|personalized)\/)?articles\/([a-z0-9][a-z0-9-]{0,79})$/.exec(
      url.pathname,
    );
  return match && (safe.startsWith('/') || url.origin === new URL(apiOrigin).origin)
    ? `${basePath}/${encodeURIComponent(match[1])}${url.hash}`
    : safe;
}

export function isHostedVideo(url: string): boolean {
  return (
    /^https:\/\/www\.youtube-nocookie\.com\/embed\/[\w-]{11}$/.test(url) ||
    /^https:\/\/player\.vimeo\.com\/video\/\d+$/.test(url)
  );
}
